/** * @Description: 素材列表页 * @author zhaijiayu * @date 2021/8/25 */
<template>
  <div class="material-container">
    <div class="materialNavContain">
      <div class="materialNav" :class="{ materialActive: materialIndex == 0 }" @click="navClick(0)">
        <div class="materialNavText">我的素材</div>
        <div class="line"></div>
      </div>
      <div class="materialNav" :class="{ materialActive: materialIndex == 1 }" @click="navClick(1)">
        <div class="materialNavText">公共素材</div>
        <div class="line"></div>
      </div>
    </div>

    <div class="actionContain">
      <div class="action-bar" style="background: none">
        <!--      添加素材-->
        <div class="func-bar">
          <!-- <el-button type="primary" icon="el-icon-plus" @click="gotoAdd" v-if="materialIndex == 0">
            {{ materialIndex == 1 ? "新增素材" : "上传素材" }}
          </el-button> -->
        </div>
      </div>
      <div class="action-bar sub">
        <div class="func-bar">
          <!--        状态筛选-->
          <el-select v-if="materialIndex == 0" v-model="filterOption.check" @change="handleTitleChange">
            <el-option :value="parseInt(key)" v-for="(value, key) in auditStatusList" :key="value + key" :label="value">
            </el-option>
          </el-select>
          <!--      日期筛选-->
          <el-date-picker v-model="filterOption.timeRange" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" @change="handleDateChange" />
          <!--        关键字筛选-->
          <el-input :clearable="true" v-model="filterOption.title" prefix-icon="el-icon-search" placeholder="请输入关键词"
            @change="handleTitleChange" style="margin-right: 0" />
        </div>
      </div>
    </div>

    <!--    素材列表组件-->
    <material-list :material-list="materialList" :refresh-list="handleDateChange" />
    <div class="footer">
      <!--    分页组件-->
      <el-pagination background @current-change="handlePageChange" :current-page="pageConfig.page"
        :page-size="pageConfig.size" layout="total, prev, pager, next, jumper" :total="pageConfig.total">
      </el-pagination>
    </div>

    <BanDialog ref="banShow" :isShow="isBanned" :allowClose="true" @closeBan="isBanned = false"></BanDialog>
  </div>
</template>
<script>
import materialList from "./components/list.vue";
import tools, { getFormatDate } from "../../utils/tools";
import { RESOURCE_HOST } from "../../constants/apiHosts";
import { MATERIAL_AUDIT_STATUS } from "../../constants/manuscript";
import BanDialog from "../../components/banDialog.vue";

export default {
  name: "material",
  components: {
    MaterialList: materialList,
    BanDialog,
  },
  created() {
    this.materialIndex = parseInt(this.$route.query.type) || 0;

    this.initFilterOption();
  },
  mounted() {
    this.getMaterialList();
  },
  computed: {
    auditStatusList: function () {
      return MATERIAL_AUDIT_STATUS;
    },
  },
  data: function () {
    return {
      materialIndex: 0,
      mysetList: [
        {
          name: "我的素材",
          value: 0,
        },
        {
          name: "全部素材",
          value: 1,
        },
      ],
      typeList: [
        {
          name: "全部",
          value: 0,
        },
        {
          name: "文稿",
          value: 1,
        },
        {
          name: "图片",
          value: 2,
        },
      ],
      // 筛选选项
      filterOption: {
        myset: 0,
        type: 2,
        title: "",
        check: 2,
        timeRange: [],
      },
      pageConfig: {
        page: 1,
        total: 0,
        size: 24,
      },
      materialList: [],
      isBanned: false,
    };
  },
  methods: {
    navClick(index) {
      this.materialIndex = index;
      this.pageConfig.page = 1;
      this.getMaterialList();
    },
    /**
     * 获取素材列表
     */
    getMaterialList: async function () {
      const time =
        this.filterOption.timeRange?.length > 0
          ? `${getFormatDate(this.filterOption.timeRange[0])},${getFormatDate(
            this.filterOption.timeRange[1]
          )}`
          : "";
      // 针对全部的类型删选做一次映射
      const type =
        parseInt(this.filterOption.type) === 0 ? "" : this.filterOption.type;
      const check =
        parseInt(this.filterOption.check) === 0 ? "" : this.filterOption.check;
      const reqOption = {
        all: this.materialIndex,
        cm_type: type,
        cm_title: this.filterOption.title,
        cm_create_time: time,
        cm_check: check,
        page: this.pageConfig.page,
        per_page: this.pageConfig.size,
      };
      try {
        const { data } = await this.$axios(
          `${RESOURCE_HOST}/api/material/list`,
          {
            method: "POST",
            data: reqOption,
          }
        );
        this.pageConfig.total = data.data.total;
        this.materialList = data.data.data;
      } catch (e) {
        console.error(e);
      }
    },
    /**
     * 素材范围变更
     * @param myset {number} 素材范围
     */
    handleMysetChange: async function (myset) {
      this.materialIndex = myset;
      this.initFilterOption();
      this.resetPage();
      await this.getMaterialList();
    },
    /**
     * 素菜类型变更
     * @param type {number} 素材类型
     */
    handleTypeChange: async function (type) {
      this.filterOption.type = type;
      this.resetPage();
      await this.getMaterialList();
    },
    /**
     * 搜索标题变更
     */
    handleTitleChange: async function () {
      this.resetPage();
      await this.getMaterialList();
    },
    /**
     * 页数变更
     * @param page {number} 页数
     */
    handlePageChange: async function (page) {
      document.getElementsByTagName("html")[0].scrollTop = 0;

      this.pageConfig.page = page;
      await this.getMaterialList();
    },
    /**
     * 重置页数
     */
    resetPage: function () {
      this.pageConfig.page = 1;
    },
    /**
     * 日期变更处理函数
     */
    handleDateChange: async function () {
      this.resetPage();
      await this.getMaterialList();
    },
    gotoAdd: function () {
      // let banData = localStorage.getItem("banData");
      // if (banData) {
      //   banData = JSON.parse(banData);
      // }
      // if (banData.ban_type == 1) {
      //   this.$refs.banShow.getReason(localStorage.getItem("token"));
      //   this.isBanned = true;
      //   return;
      // }

      window.open(this.$router.resolve({ name: "addMaterial" }).href, "_blank");
    },
    /**
     * 初始化默认的筛选项
     */
    initFilterOption: function () {
      // 全部线索只展示已经审核通过的数据
      if (this.materialIndex == 1) {
        this.filterOption.check = 2;
      } else {
        this.filterOption.check = 0;
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../styles/variables";

.material-container {
  padding: 0 24px 20px;
  background: #ffffff;
  border-radius: 8px;

  .materialNavContain {
    display: flex;
    border-bottom: 1px solid #eeeeee;
    width: calc(100% + 48px);
    margin-left: -24px;

    .materialNav {
      display: flex;
      flex-direction: column;
      align-items: center;

      .materialNavText {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 18px;
        font-weight: 500;
        line-height: 66px;
        padding: 0 24px;
        cursor: pointer;
      }

      .line {
        width: 36px;
        height: 3px;
        background: #fff;
      }
    }

    .materialActive {
      .line {
        background: #f32432;
      }
    }
  }

  .actionContain {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .action-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .tab-filter {
      display: inline-flex;

      .tab-filter-item {
        padding: 20px 0;
        cursor: pointer;
        margin-right: 56px;
        color: $text-color-main;
        font-weight: bold;
        font-size: 18px;
      }

      .tab-filter-item.active {
        border-bottom: 3px solid $theme-color;
      }
    }

    .func-bar {
      float: right;
      display: flex;
      justify-content: space-between;
    }

    /deep/.el-range-separator {
      width: 22px !important;
    }

    /deep/.el-input {
      width: 150px;
      height: 40px;
      margin-bottom: 0;
    }

    /deep/.el-select {
      width: 150px;
      margin: 0 20px 0 0;
    }

    /deep/.el-date-editor {
      width: 250px;
      margin: 0 20px 0 0;
    }
  }

  .action-bar.sub {
    margin: 20px 0;
  }

  .footer {
    background: #fff;
    text-align: right;
    overflow: hidden;

    /deep/.el-pagination {
      margin-top: 0;
    }
  }
}
</style>
